"use client";
import React from "react";
import IntroAnimation from "./components/other/IntroAnimation.tsx";
import Blur from "./components/overlay/Blur.tsx";
import Color from "./components/overlay/Color.tsx";
import CursorEffect from "./components/cursor/CursorEffect.tsx";
import Hero from "./sections/Hero.tsx";
import About from "./sections/About.tsx";
import Work from "./sections/Work.tsx";
import Contact from "./sections/Contact.tsx";
import Footer from "./sections/Footer.tsx";
import Tools from "./sections/Tools.tsx";
import NavBar from "./sections/NavBar.tsx";

export default function Home() {
    return (
        <>
            <IntroAnimation />
            <CursorEffect />
            <Blur />
            <NavBar />
            <Color />
            <main className="flex flex-col items-center justify-center bg-black">
                <Hero />
                {/* <About /> */}
                <Work />
                <Tools />
                <Contact />
                <Footer />
            </main>
        </>
    );
}
